<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <div class="component-header-title">
      <h2>Edit Company</h2>
      @if (companyName()) {
        <p class="component-header-subtitle">
          @if (companyCode()) {
            <span class="company-code">{{ companyCode() }}</span>
          }
          {{ companyName() }}
        </p>
      }
      @if (companyCountry()) {
        <p class="component-header-subtitle-secondary">{{ companyCountry() }}</p>
      }
    </div>
    <div class="component-header-actions">
      @if (processStatus(); as status) {
        <div class="process-status-section" [class.no-data]="!status.hasData">
          <span class="process-status-year">{{ status.year }}</span>
          <div class="process-status-divider"></div>
          @for (cat of status.categories; track cat.key; let isLast = $last) {
            <div class="process-status-item">
              <span class="process-status-category">{{ status.categories.length > 1 ? cat.shortLabel : cat.label }}</span>
              @if (!isUserRole) {
                <span class="type-badge" [class.status-true]="status.hasData && cat.isChecked" [class.status-false]="status.hasData && !cat.isChecked"
                  [matTooltip]="formatTooltip(cat.checkedDate, cat.checkedByUser)" [matTooltipDisabled]="!cat.checkedDate && !cat.checkedByUser">C</span>
              }
              <span class="type-badge" [class.status-true]="status.hasData && cat.isFinished" [class.status-false]="status.hasData && !cat.isFinished"
                [matTooltip]="formatTooltip(cat.finishedDate, cat.finishedByUser)" [matTooltipDisabled]="!cat.finishedDate && !cat.finishedByUser">F</span>
            </div>
            @if (!isLast) {
              <div class="process-status-divider"></div>
            }
          }
        </div>
      }
      <button mat-icon-button [matMenuTriggerFor]="companyEditMenu" aria-label="Company actions">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu class="company-edit-menu" #companyEditMenu="matMenu">
        <div class="company-edit-menu-container">
          @if (isDeveloper) {
            <div class="company-edit-menu-item" (click)="onViewAuditLog()">
              <div class="company-edit-menu-item-icon">
                <mat-icon>history</mat-icon>
              </div>
              <div class="company-edit-menu-item-text">View Audit Log</div>
            </div>
          }
          <div class="company-edit-menu-item" [class.disabled]="!canFixDirectors" (click)="canFixDirectors && onFixDirectors()">
            <div class="company-edit-menu-item-icon">
              <mat-icon>build</mat-icon>
            </div>
            <div class="company-edit-menu-item-text">Fix Directors</div>
          </div>
        </div>
      </mat-menu>
    </div>
  </div>
  <app-company-form
    [isEditMode]="true"
    submitButtonText="Update Company"
    (submit)="onSubmit()"
    (cancel)="onCancel()"
    (processStatusChange)="processStatus.set($event)">
  </app-company-form>
</div>
